import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "numeric-quarter-table" }

import { PropType } from 'vue';
import NumericViewMode from '@/core/Values/NumericViewMode';


export default /*@__PURE__*/_defineComponent({
  __name: 'VNumericQuarterTable',
  props: {
    viewMode: { type: Number as PropType<NumericViewMode>, default: NumericViewMode.Proportion },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { viewMode: __props.viewMode })
  ]))
}
}

})